import { sanitizeParams } from '../auth/check-params';
import { BRAZE_EVENTS } from '../utils.constant';
import { AnalyticsUtils } from '../analytics/AnalyticsUtils';
import { analyticsEmitter } from './AnalyticsEventEmitter';
export class Braze {
    static onLoad(callback) {
        this.setUser();
        import('../braze-exports').then(({ logCustomEvent }) => {
            logCustomEvent('App Load', {
                Pagetype: AnalyticsUtils.getPage(),
                'Page source': sanitizeParams(),
            });
            callback();
        });
    }
    static setUser() {
        const userId = AnalyticsUtils.getUserId();
        if (userId) {
            import('../braze-exports').then(({ changeUser }) => {
                changeUser(userId.toString());
                this.setUserProperties();
            });
        }
    }
    static setUserProperties() {
        const sanitizedUser = AnalyticsUtils.getSanitizedUser();
        import('../braze-exports').then(({ getUser }) => {
            const brazeUser = getUser();
            brazeUser.setFirstName(sanitizedUser.first_name);
            brazeUser.setLastName(sanitizedUser.last_name);
            brazeUser.setEmail(sanitizedUser.email);
        });
    }
    static setUserCustomAttributes(userProperties = {}) {
        import('../braze-exports').then(({ getUser }) => {
            const brazeUser = getUser();
            for (const [key, value] of Object.entries(userProperties)) {
                brazeUser.setCustomUserAttribute(key, value.toString());
            }
        });
    }
    static load(config, callback = () => { }) {
        this.init(config).then(() => {
            this.startSession();
            this.onLoad(callback);
        });
    }
    static startSession() {
        import('../braze-exports').then(({ openSession, automaticallyShowInAppMessages }) => {
            automaticallyShowInAppMessages();
            openSession();
        });
    }
    static init(config) {
        return new Promise((resolve, reject) => {
            import('../braze-exports').then(({ initialize }) => {
                initialize(config?.API_KEY, {
                    baseUrl: 'sdk.iad-05.braze.com',
                    enableLogging: false,
                    minimumIntervalBetweenTriggerActionsInSeconds: 10,
                });
            });
            this.isReady = true;
            analyticsEmitter.emit('braze', { isReady: true });
            resolve(true);
        });
    }
    static sendEvent(data) {
        let brazeEventProperties, brazeUserProperties = {};
        if (data?.userProperties) {
            brazeUserProperties = this.filterBrazeProperties(data?.userProperties, 'user_properties', data.eventName);
        }
        if (data?.eventProperties) {
            brazeEventProperties = this.filterBrazeProperties(data?.eventProperties, 'event_properties', data.eventName);
        }
        import('../braze-exports').then(({ logCustomEvent }) => {
            logCustomEvent(data.eventName, brazeEventProperties);
        });
        if (Object.keys(brazeUserProperties).length > 0) {
            this.setUserCustomAttributes(brazeUserProperties);
        }
    }
    static filterBrazeProperties(properties, property_type, eventName) {
        let attributes = {};
        if (BRAZE_EVENTS.hasOwnProperty(eventName)) {
            const brazeEvent = BRAZE_EVENTS[eventName];
            const whitelistedProperties = brazeEvent[property_type];
            for (let prop in properties) {
                if (whitelistedProperties.length > 0 &&
                    whitelistedProperties.includes(prop)) {
                    attributes[prop] = properties[prop];
                }
            }
        }
        return attributes;
    }
}
Braze.isReady = false;
